import React, { Component } from 'react';
import Styles from "../Styles.js";
import { Field } from 'react-final-form';
import { OnChange } from 'react-final-form-listeners';
import Checkbox from "./checkbox.js";
import { ERRORSTYLE } from "../util/constants";

export class ProjectResource extends Component {
    constructor(props) {
        super(props);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.state = {
            deny: false
        }
    }

    handleCheckboxChange(e, res) {
        this.props.change(e, res);
    }

    render() {
        const { res, provision, checked, navigate, projectId, isAdmin } = this.props;
        const { deny } = this.state;
        let pfields = [];
        if (provision && checked && !deny) {
            pfields = res.provision_fields;
        }
        const required = value => (value ? undefined : "Required");
        const resIndex = res.index || 0;

        return (
            <Styles>
                <label style={{margin: "5px 0 2px", display: "flex", alignItems: "center", justifyContent: "flex-start", width: "100%"}}>
                  {provision && <Checkbox
                      checked={checked || false}
                      onChange={(e) => {this.handleCheckboxChange(e, res)}}
                  />}
                  <h3 style={{margin: "0 15px 0"}} className="project-resource">
                    {isAdmin
                      ? <div className="log-link" onClick={() => navigate(`log/${projectId}-${resIndex}`)}>{res.name}</div>
                      : <div>{res.name}</div>}
                  </h3>
                </label>
                {provision && checked && <label>
                    <Field
                        name="denied"
                        component="input"
                        type="checkbox"
                        value={res.name}
                    />
                    <OnChange name="denied">
                        {(value) => {
                            const res = this.props.res.name
                            const current = this.state.deny
                            const deny = value.includes(res)
                            if (current !== deny) {
                                this.setState({ deny })
                            }
                        }}
                    </OnChange>
                    Deny resource
                    { deny && <Field
                            name={res.index + "-reason" }
                            component="input"
                            validate={required}
                        >
                            {({ input, meta }) => (
                                <div>
                                        <input {...input} type="text" placeholder="reason" />
                                        {meta.error && meta.touched && <span style={ERRORSTYLE}> {meta.error}</span>}
                                </div>
                            )}
                        </Field>
                    }
                </label>}
                <table className="project-tags" cellSpacing="0" style={{border: "2px solid #000"}}>
                    <tbody>
                        <tr key="headings">
                            <td className="headings-row">Name</td>
                            <td className="headings-row">Value</td>
                        </tr>
                        {res.tags.map((tag, idx) =>
                            <tr key={idx}>
                                <td>{tag.name}</td><td>{tag.value}</td>
                            </tr>
                        )}
                        {pfields.length > 0 && pfields.map((name, idx) =>
                            <tr key={idx}>
                                <td><label>{name}</label></td>
                                <td>
                                    <Field
                                        name={res.index + "-" + name}
                                        component="input"
                                        placeholder="required"
                                        validate={required}
                                    >
                                        {({ input, meta }) => (
                                            <div>
                                                    <input {...input} type="text" />
                                                    {meta.error && meta.touched && <span style={ERRORSTYLE}> {meta.error}</span>}
                                            </div>
                                        )}
                                    </Field>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </Styles>
        )
    }
}

export function ProjectResources(props) {
    const { project, navigate, isAdmin } = props;
    return (
    <Styles>
        <h2>Project Resources</h2>
        {project.resources && project.resources.map((res, ridx) =>
            <ProjectResource key={ridx} res={res} navigate={navigate} projectId={project.id} isAdmin={isAdmin} />
        )}
    </Styles>
    );
}

export function ProvisionResources(props) {
    return (
        <Styles>
            {props.project.resources && props.project.resources.map((res, ridx) =>
                <ProjectResource
                    provision={true}
                    checked={props.active[res.index]}
                    change={props.handleCheckboxChange}
                    key={ridx}
                    res={res}
                />
            )}
        </Styles>
    );
}
